export enum ActivityCardVariant {
  ACTIONS_AMOUNT = 'actions_amount',
  LAST_ACTION = 'last_action',
  ACTIONS_TIME = 'actions_time',
}
